import React from 'react';
import { Ban, LogOut } from 'lucide-react';
import { supabase } from '../lib/supabaseClient';

export default function AccountDisabledPage({ email }) {
  const handleLogout = async () => {
    if (supabase) await supabase.auth.signOut();
  };
  return (
    <div className="auth-screen" data-testid="account-disabled-page">
      <div className="auth-card" style={{ maxWidth: 440, padding: 36 }}>
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          gap: 14, marginBottom: 32,
        }}>
          <img
            src="/vv-logo.svg"
            alt="Vårdväskan"
            width={48}
            height={48}
            style={{ display: 'block', borderRadius: 11, flexShrink: 0 }}
          />
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.15 }}>
            <span style={{
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontSize: 19, fontWeight: 700, color: '#f1f5f9', letterSpacing: '-0.01em',
            }}>
              Vårdväskan
            </span>
            <span style={{
              fontSize: 11, fontWeight: 600, letterSpacing: '0.14em',
              color: 'rgba(241, 245, 249, 0.55)', textTransform: 'uppercase',
              marginTop: 3,
            }}>
              AI Studio
            </span>
          </div>
        </div>

        <div style={{ textAlign: 'center' }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 64, height: 64, borderRadius: '50%',
            background: 'rgba(239, 68, 68, 0.15)', color: '#fca5a5',
            border: '1px solid rgba(239, 68, 68, 0.4)',
            marginBottom: 22,
          }}>
            <Ban size={28} />
          </div>
          <h2 style={{
            fontSize: 22, fontWeight: 600, margin: '0 0 12px',
            color: '#f1f5f9', letterSpacing: '-0.01em',
          }}>
            Ditt konto är inaktiverat
          </h2>
          <p style={{
            color: 'rgba(241, 245, 249, 0.78)', fontSize: 14, lineHeight: 1.6,
            margin: '0 auto 24px', maxWidth: 340,
          }}>
            Kontakta en administratör om du vill ha tillgång igen.
          </p>
          {email && (
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 10,
              padding: '10px 16px', marginBottom: 28,
              background: 'rgba(255, 255, 255, 0.06)',
              border: '1px solid rgba(255, 255, 255, 0.12)',
              borderRadius: 10,
              fontSize: 13, color: '#f1f5f9',
              maxWidth: '100%',
            }}>
              <span style={{ color: 'rgba(241, 245, 249, 0.6)', fontSize: 12, whiteSpace: 'nowrap' }}>
                Inloggad som
              </span>
              <strong style={{ color: '#ffffff', fontWeight: 600, wordBreak: 'break-all' }}>{email}</strong>
            </div>
          )}
          <div>
            <button
              type="button"
              onClick={handleLogout}
              data-testid="disabled-logout-btn"
              style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                minWidth: 160, padding: '11px 22px',
                fontSize: 13, fontWeight: 600, color: '#ffffff',
                background: 'rgba(255, 255, 255, 0.06)',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                borderRadius: 10,
                cursor: 'pointer',
                transition: 'background 0.15s ease, border-color 0.15s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.12)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.06)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.25)';
              }}
            >
              <LogOut size={14} /> Logga ut
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
